"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var images_1 = require("../state/images");
var measurements_gql_1 = require("../state/measurements.gql");
var ImageSlider_1 = __importDefault(require("./ImageSlider"));
var react_redux_1 = require("react-redux");
var Annotations_1 = require("./Annotations");
var MeasuredAppImageSlider = /** @class */ (function (_super) {
    __extends(MeasuredAppImageSlider, _super);
    function MeasuredAppImageSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyPress = function (ev) {
            var RIGHT = 39;
            var LEFT = 37;
            if (!_this.props.showSizeChart) {
                if (ev.keyCode === LEFT) {
                    _this.props.previousImage();
                }
                else if (ev.keyCode === RIGHT) {
                    _this.props.nextImage();
                }
            }
        };
        return _this;
    }
    MeasuredAppImageSlider.prototype.render = function () {
        var _a = this.props, featuredImageIndex = _a.featuredImageIndex, canToggleGraphics = _a.canToggleGraphics, showSizeChartFn = _a.showSizeChartFn, trialExpired = _a.trialExpired;
        // buttons are hover on large screens
        var isTouchScreen = "ontouchstart" in window;
        var isDesktop = window.innerWidth > 800 && !isTouchScreen;
        var imageSliderHTML = React.createElement(ImageSlider_1.default, __assign({}, this.props, { imageIndex: featuredImageIndex, showImagePreviews: true, canToggleGraphics: canToggleGraphics, canToggleDisplayUnit: true, toggleActionButtonsOnHover: true, zoomable: isDesktop, largeScreen: isDesktop, enableSliderArrows: false, showSizeChartAction: showSizeChartFn, showExpiredNotice: trialExpired }));
        return React.createElement("div", null, imageSliderHTML);
    };
    MeasuredAppImageSlider.prototype.componentWillMount = function () {
        document.addEventListener("keydown", this.handleKeyPress);
    };
    MeasuredAppImageSlider.prototype.componentDidMount = function () {
        var _this = this;
        var showMeasurements = window.location.hash === "#showMeasurements";
        var showSizeChart = window.location.hash === "#showSizeChart";
        this.props.loadSizeChartAndAnnotations(this.props.shopifyProductId, showMeasurements, showSizeChart);
        // create listeners on links with #showMeasurements or #showSizeChart
        var allLinks = Array.prototype.slice.call(document.querySelectorAll("a"));
        allLinks.forEach(function (element, idx) {
            var target = element.getAttribute("href");
            if (target === "#showMeasurements") {
                element.onclick = function (ev) {
                    ev.preventDefault();
                    var display = _this.props.annotationsDisplay;
                    if (display === Annotations_1.AnnotationsDisplay.HIDE) {
                        _this.props.showGraphics();
                    }
                    else if (display === Annotations_1.AnnotationsDisplay.SHOW_MEASUREMENTS) {
                        _this.props.hideGraphics();
                    }
                };
            }
            if (target === "#showSizeChart") {
                element.onclick = function (ev) {
                    ev.preventDefault();
                    if (!_this.props.showSizeChart) {
                        _this.props.showSizeChartFn();
                    }
                };
            }
        });
    };
    MeasuredAppImageSlider.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.handleKeyPress);
    };
    return MeasuredAppImageSlider;
}(React.PureComponent));
var mapStateToProps = function (state) {
    return {
        shopifyProductId: state.images.shopifyProductId,
        images: state.images.images,
        featuredImageIndex: state.images.featuredImageIndex,
        displayUnit: state.measurements.displayUnit,
        displayVariantId: state.measurements.displayVariantId,
        graphics: state.measurements.graphics,
        canToggleGraphics: state.measurements.canToggleGraphics,
        sizeChart: state.measurements.sizeChart,
        showSizeChart: state.measurements.showSizeChart,
        canToggleSizeChart: state.measurements.canToggleSizeChart,
        optionLabels: state.measurements.optionLabels,
        annotationsDisplay: state.measurements.annotationsDisplay,
        trialExpired: state.measurements.trialExpired,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        nextImage: function () { return dispatch({ type: images_1.ImagesActionType.SHOW_NEXT_IMAGE }); },
        previousImage: function () { return dispatch({ type: images_1.ImagesActionType.SHOW_PREVIOUS_IMAGE }); },
        selectImage: function (imageIndex) { return dispatch({ type: images_1.ImagesActionType.SHOW_IMAGE, imageIndex: imageIndex }); },
        showSizeChartFn: function () { return dispatch({ type: measurements_gql_1.MeasurementActionType.SHOW_SIZE_CHART }); },
        toggleDisplayUnit: function () { return dispatch({ type: measurements_gql_1.MeasurementActionType.TOGGLE_UNIT }); },
        showGraphics: function () { return dispatch({ type: measurements_gql_1.MeasurementActionType.SHOW_MEASUREMENT_GRAPHICS }); },
        hideGraphics: function () { return dispatch({ type: measurements_gql_1.MeasurementActionType.HIDE_GRAPHICS }); },
        loadSizeChartAndAnnotations: function (shopifyProductId, showMeasurements, showSizeChart) {
            measurements_gql_1.loadSizeChartAndAnnotations(shopifyProductId, dispatch, showMeasurements, showSizeChart);
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MeasuredAppImageSlider);
